export const CUSTOM_ORDER_LIMITS = Object.freeze({
  title: 160,
  description: 5000,
  referenceText: 1000,
  quantity: 100,
  budget: 100000000,
  message: 4000,
});

export function getTodayIsoDate(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function parseOptionalAmount(value, label, errors, field) {
  if (value === undefined || value === null || String(value).trim() === '') return null;

  const amount = Number(value);
  if (!Number.isFinite(amount) || amount < 0 || amount > CUSTOM_ORDER_LIMITS.budget) {
    errors[field] = `${label} must be a valid non-negative amount.`;
    return null;
  }

  return amount;
}

export function validateCustomOrderForm(formData, { today = getTodayIsoDate() } = {}) {
  const normalized = {
    title: String(formData?.title || '').trim(),
    description: String(formData?.description || '').trim(),
    referenceText: String(formData?.referenceText || '').trim(),
    quantity: String(formData?.quantity ?? '1').trim() || '1',
    budget: String(formData?.budget ?? '').trim(),
    suggestedDeadline: String(formData?.suggestedDeadline || '').trim(),
  };
  const errors = {};

  if (!normalized.title) errors.title = 'Tell us what you would like made.';
  else if (normalized.title.length > CUSTOM_ORDER_LIMITS.title) errors.title = `Use ${CUSTOM_ORDER_LIMITS.title} characters or fewer.`;

  if (!normalized.description) errors.description = 'Describe the item, style, colours, or other details you need.';
  else if (normalized.description.length > CUSTOM_ORDER_LIMITS.description) errors.description = `Use ${CUSTOM_ORDER_LIMITS.description} characters or fewer.`;

  if (normalized.referenceText.length > CUSTOM_ORDER_LIMITS.referenceText) errors.referenceText = `Use ${CUSTOM_ORDER_LIMITS.referenceText} characters or fewer.`;

  const quantity = Number(normalized.quantity);
  if (!/^\d+$/.test(normalized.quantity) || !Number.isInteger(quantity) || quantity < 1 || quantity > CUSTOM_ORDER_LIMITS.quantity) {
    errors.quantity = `Enter a whole number from 1 to ${CUSTOM_ORDER_LIMITS.quantity}.`;
  }

  parseOptionalAmount(normalized.budget, 'Budget', errors, 'budget');

  if (normalized.suggestedDeadline) {
    const date = new Date(`${normalized.suggestedDeadline}T00:00:00.000Z`);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(normalized.suggestedDeadline) || Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== normalized.suggestedDeadline) {
      errors.suggestedDeadline = 'Enter a valid completion date.';
    } else if (normalized.suggestedDeadline < today) {
      errors.suggestedDeadline = 'Choose today or a future date.';
    }
  }

  return { normalized, errors };
}
